interface RulesMap {
  [tipo_regime: number]: {
    [situacaoTributaria: string]: number[];
  };
}

/**
 * relacao entre tipo do regime com o tipo de tributacao e st
 *
 * ex: tipo regime 0: cst '000' deve estar com o
 * tipo de tributacao [0] - "Tributado"
 *
 * tipo regime
 * 0: Lucro Real
 * 1: Lucro Presumido
 * 2: Optante Simples
 */

export const rulesMap: RulesMap = {
  0: {
    '000': [0],
    '010': [3],
    '020': [2],
    '030': [3],
    '040': [1],
    '041': [8],
    '050': [4],
    '051': [5],
    '060': [3],
    '061': [3],
    '070': [3],
    '090': [6],
  },
  2: {
    '101': [0],
    '102': [0],
    '103': [1],
    '201': [3],
    '202': [3],
    '203': [3],
    '300': [9],
    '400': [8],
    '500': [3],
    '900': [6],
  },
};
